// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"62":"28dfd5f7","173":"fee7673e","326":"b1940699","578":"a9565f00","833":"77646d55","941":"791d0644"}[chunkId] + ".chunk.css";
};